/**
 * StageProgress — the free-play arcade game on this device (stage, lives,
 * energy) and the best wood balance reached. Verified games live on the
 * server (/api/game); both follow src/shared/stage/arcade.js.
 */

import { newGame, woodLogs } from "../../shared/stage/arcade";

const KEY = "woodchuck_stage_progress";

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}

function write(value) {
  try {
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // storage unavailable (private mode) — the game just isn't kept
  }
  return value;
}

const StageProgress = {
  get() {
    const saved = read();
    const bestWood = Number.isInteger(saved.bestWood) ? saved.bestWood : 0;
    const game = Number.isInteger(saved.stage) && Number.isInteger(saved.lives) ? saved : newGame();
    return { ...newGame(), ...game, bestWood };
  },

  /** @param {{ stage: number, lives: number, bankWh: number, over: boolean, finished: boolean }} game */
  save(game) {
    const bestWood = Math.max(this.get().bestWood, woodLogs(game.bankWh));
    return write({ ...game, bestWood });
  },

  /** Game over: a new game from stage 1 (the best wood is kept). */
  reset() {
    return write({ ...newGame(), bestWood: this.get().bestWood });
  },
};

export default StageProgress;
